import React, { useState, useEffect } from "react";



import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import DateFnsUtils from "@date-io/date-fns";

import Footer from "../Components/Footer";

import WhyUs from "../Components/WhyUs";

import VieweventDetails from "../Components/VieweventDetails";

import Api from "../Service/Api";

import EventDetailsCard from "../Components/EventDetailsCard";

import Loaders from "../Components/FullScreenLoader";

import {

  getEventIdFromMatch,

  getEventPath,

} from "../utils/eventUrl";



const ViewSingleEvent = (props) => {

  const [list, setList] = useState("");

  const [loader, setLoader] = useState(true);

  const eventId = getEventIdFromMatch(props.match);



  useEffect(() => {

    geteventlist();

  }, [eventId]);



  const geteventlist = () => {

    if (!eventId) {

      return;

    }



    Api.get(

      `/events/${eventId}?&relations=["eventImages","tags","user","faqs","kitlist","itineraries","additionals","includes"]`

    )

      .then((res) => {

        setList(res.data);

        setLoader(false);



        const canonicalPath = getEventPath(res.data.id, res.data.title);

        if (props.location.pathname !== canonicalPath) {

          props.history.replace(canonicalPath);

        }

      })

      .catch((err) => {

        setLoader(false);

      });

  };



  return (

    <div style={{ position: "relative" }}>

      {loader && <Loaders />}

      <EventDetailsCard

        history={props.history}

        id={eventId}

        list={list}

      />

   

      <Footer />

    </div>

  );

};



export default ViewSingleEvent;

